module.exports = __webpack_public_path__ + "static/media/Saurabh.708274d2.jpg";